import React, { Component } from 'react';
import { Tabs, Button, message } from 'antd';
import FilterBasic from '../../basicElement/FilterBasic';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import TableC from '../../basicElement/TableC';
import moment from 'moment';

const { TabPane } = Tabs;
const monthFormat = 'YYYY-MM';

class Filter extends Component {
    handleChange = (params, key) => {
        if (key === 'investigationAreaId') {
            const { areaOptions } = this.props;
            const { label } = (areaOptions || []).find(i => i.value == params['investigationAreaId']) || {};
            params.investigationAreaName = label;
            this.props.onChange(params, key);
        } else {
            this.props.onChange(params, key);
        }
    }

    render() {
        const { areaOptions, ...rest } = this.props;
        const filters = [{
            name: '统计月份',
            key: 'end',
            type: 'monthPicker',
            typeProperty: {
                allowClear: false,
            }
        }, {
            name: '项目领域',
            key: 'investigationAreaId',
            type: 'select',
            typeProperty: {
                allowClear: false,
                list: areaOptions,
            }
        }];
        return (
            <FilterBasic filters={filters} {...rest} onChange={this.handleChange} />
        )
    }
}

class ByCrc extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvAreaByCRC,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            fixed: 'left',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 90,
        }, {
            title: '该城市CRC总人数',
            dataIndex: 'cityCrcNum',
            key: 'cityCrcNum',
            width: 80,
        }, {
            title: '有CRC驻点的中心数量',
            dataIndex: 'cityHospitalNum',
            key: 'cityHospitalNum',
            width: 80,
        }, {
            title: `该地区参与${investigationAreaName}项目的中心(举例)`,
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 130,
        }, {
            title: `该中心参与的${investigationAreaName}项目数量`,
            children:[
                {title:'所有项目',
                dataIndex:'siteInvNum',
                key:'siteInvNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'tumourInvProgressNum',
                key:'tumourInvProgressNum',
                width:120},
            ]
            // dataIndex: 'siteInvNum',
            // key: 'siteInvNum',
            // width: 120,
        }, {
            title: `该中心参与${investigationAreaName}项目的CRC人数`,
            children:[
                {title:'所有项目',
                dataIndex:'hospitalCrcNum',
                key:'hospitalCrcNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'hospitalCrcProgressNum',
                key:'hospitalCrcProgressNum',
                width:120},
            ]
            // dataIndex: 'hospitalCrcNum',
            // key: 'hospitalCrcNum',
            // width: 120,
        }, {
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 100,
        }, {
            title: `该科室参与的${investigationAreaName}项目数量`,
            children:[
                {title:'所有项目',
                dataIndex:'depInvNum',
                key:'depInvNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'depInvProgressNum',
                key:'depInvProgressNum',
                width:120},
            ]
            // dataIndex: 'depInvNum',
            // key: 'depInvNum',
            // width: 120,
        }, {
            title: `该科室参与${investigationAreaName}项目的CRC人数`,
            children:[
                {title:'所有项目',
                dataIndex:'departmentCrcNum',
                key:'departmentCrcNum',
                width:130},
                {title:'进行中项目',
                dataIndex:'departmentCrcProgressNum',
                key:'departmentCrcProgressNum',
                width:130},
            ]
            // dataIndex: 'departmentCrcNum',
            // key: 'departmentCrcNum',
            // width: 130,
        }, {
            title: `该中心该科室上参与${investigationAreaName}项目的CRC人员名单`,
            children: [{
                title: '工号',
                dataIndex: 'employeeCode',
                key: 'employeeCode',
                width: 90,
            }, {
                title: '姓名',
                dataIndex: 'userCompellation',
                key: 'userCompellation',
                width: 90,
            }, {
                title: '工作城市',
                dataIndex: 'workCity',
                key: 'workCity',
                width: 90,
            }, {
                title: '领域经验(月)',
                dataIndex: 'workMonthNum',
                key: 'workMonthNum',
                width: 100,
            }],
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byCrc"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class ByDepartment extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvAreaByCRC,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                type: 'DEPARTMENT',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            fixed: 'left',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 90,
        }, {
            title: '该城市CRC总人数',
            dataIndex: 'cityCrcNum',
            key: 'cityCrcNum',
            width: 80,
        }, {
            title: '有CRC驻点的中心数量',
            dataIndex: 'cityHospitalNum',
            key: 'cityHospitalNum',
            width: 80,
        }, {
            title: `该地区参与${investigationAreaName}项目的中心(举例)`,
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 130,
        }, {
            title: `该中心参与的${investigationAreaName}项目数量`,
            children:[
                {title:'所有项目',
                dataIndex:'siteInvNum',
                key:'siteInvNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'tumourInvProgressNum',
                key:'tumourInvProgressNum',
                width:120},
            ]
            // dataIndex: 'siteInvNum',
            // key: 'siteInvNum',
            // width: 120,
        }, {
            title: `该中心参与${investigationAreaName}项目的CRC人数`,
            children:[
                {title:'所有项目',
                dataIndex:'hospitalCrcNum',
                key:'hospitalCrcNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'hospitalCrcProgressNum',
                key:'hospitalCrcProgressNum',
                width:120},
            ]
            // dataIndex: 'hospitalCrcNum',
            // key: 'hospitalCrcNum',
            // width: 120,
        }, {
            title: '科室',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 100,
        }, {
            title: `该科室参与的${investigationAreaName}项目数量`,
            children:[
                {title:'所有项目',
                dataIndex:'depInvNum',
                key:'depInvNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'depInvProgressNum',
                key:'depInvProgressNum',
                width:120},
            ]
            // dataIndex: 'depInvNum',
            // key: 'depInvNum',
            // width: 120,
        }, {
            title: `该科室参与${investigationAreaName}项目的CRC人数`,
            children:[
                {title:'所有项目',
                dataIndex:'departmentCrcNum',
                key:'departmentCrcNum',
                width:130},
                {title:'进行中项目',
                dataIndex:'departmentCrcProgressNum',
                key:'departmentCrcProgressNum',
                width:130},
            ]
            // dataIndex: 'departmentCrcNum',
            // key: 'departmentCrcNum',
            // width: 130,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byDepartment"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class ByHospital extends Component {
    constructor(props) {
        super(props);
        const { searchParams } = props;
        this.state = {
            data: [],
            searchParams,
            loading: false,
            sortParams: {},
            pagination: {
                pageSize: 10,
                current: 1,
            },
        };
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { sortParams, pagination, searchParams } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.dashboard.queryInvAreaByCRC,
            data: {
                offset: current,
                limit: pageSize,
                ...sortParams,
                ...searchParams,
                type: 'HOSPITAL',
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = (searchParams) => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            pagination,
            searchParams,
        }, () => {
            this.loadData();
        });
    }

    getColumns = () => {
        const { searchParams: { investigationAreaName = '' } } = this.state;
        const columns = [{
            title: '省份',
            dataIndex: 'provinceName',
            key: 'provinceName',
            fixed: 'left',
            width: 80,
        }, {
            title: '城市',
            dataIndex: 'cityName',
            key: 'cityName',
            fixed: 'left',
            width: 100,
        }, {
            title: '该城市CRC总人数',
            dataIndex: 'cityCrcNum',
            key: 'cityCrcNum',
            width: 120,
        }, {
            title: '有CRC驻点的中心数量',
            dataIndex: 'cityHospitalNum',
            key: 'cityHospitalNum',
            width: 140,
        }, {
            title: `该地区参与${investigationAreaName}项目的中心(举例)`,
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 200,
        }, {
            title: `该中心参与的${investigationAreaName}项目数量`,
            children:[
                {title:'所有项目',
                dataIndex:'siteInvNum',
                key:'siteInvNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'tumourInvProgressNum',
                key:'tumourInvProgressNum',
                width:120},
            ]
            // dataIndex: 'siteInvNum',
            // key: 'siteInvNum',
            // width: 120,
        }, {
            title: `该中心参与${investigationAreaName}项目的CRC人数`,
            children:[
                {title:'所有项目',
                dataIndex:'hospitalCrcNum',
                key:'hospitalCrcNum',
                width:120},
                {title:'进行中项目',
                dataIndex:'hospitalCrcProgressNum',
                key:'hospitalCrcProgressNum',
                width:120},
            ]
            // dataIndex: 'hospitalCrcNum',
            // key: 'hospitalCrcNum',
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, loading, pagination, sortParams } = this.state;
        return (
            <TableC
                data={data}
                loading={loading}
                sortParams={sortParams}
                columns={this.getColumns()}
                className="byHospital"
                pagination={pagination}
                onChange={this.handleTableChange}
            />
        );
    }
}

class CrcDistributionJoinPro extends Component {
    state = {
        panes: [{
            title: '按CRC维度统计',
            key: 'byCrc',
            content: null,
        }, {
            title: '按科室维度统计',
            key: 'byDepartment',
            content: null,
        }, {
            title: '按医院维度统计',
            key: 'byHospital',
            content: null,
        }],
        activeKey: 'byCrc',
        searchParams: {
            end: moment().format(monthFormat),
        },
        curParams: {
            end: moment().format(monthFormat),
        },
        areaOptions: [],
    }

    componentDidMount() {
        this.loadAreaList();
    }

    loadAreaList = () => {
        dictCache.getDict('AREA_ALL', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryAllInvestigationArea,
                data: {},
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { curParams, searchParams } = this.state;
            const areaOptions = (res.data || []).map(item => {
                const { investigationAreaId, investigationAreaName } = item;
                if (investigationAreaName === '肿瘤') {
                    curParams.investigationAreaId = investigationAreaId + '';
                    curParams.investigationAreaName = investigationAreaName;
                    searchParams.investigationAreaId = investigationAreaId + '';
                    searchParams.investigationAreaName = investigationAreaName;
                }
                return {
                    label: investigationAreaName,
                    value: investigationAreaId,
                };
            });
            this.setState({
                areaOptions,
                curParams,
                searchParams,
            }, () => {
                this.updatePanes();
            });
        });
    }

    search = () => {
        const { searchParams } = this.state;
        this.setState({
            curParams: {...searchParams}
        }, () => {
            const { curParams } = this.state;
            this.childRef.search(curParams);
        });
    }

    export = () => {
        const { activeKey, sortParams, curParams } = this.state;
        const type = (activeKey === 'byDepartment' && 'DEPARTMENT') || (activeKey === 'byHospital' && 'HOSPITAL');
        const options = {
            method: 'POST',
            url: API_URL.dashboard.exportInvAreaByCRC,
            data: {
                ...sortParams,
                ...curParams,
                offset: 1,
                type,
            },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
            },
        };
        $.sendRequest(options);
    }
    
    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    updatePanes = () => {
        const { panes, activeKey, curParams } = this.state;
        let RenderContent = null;
        if (activeKey == 'byCrc') {
            RenderContent = ByCrc;
        } else if (activeKey == 'byDepartment') {
            RenderContent = ByDepartment;
        } else if (activeKey == 'byHospital') {
            RenderContent = ByHospital;
        }
        panes.forEach(item => {
            if (item.key == activeKey) {
                item.content = <RenderContent ref={el => this.childRef = el} searchParams={curParams} />;
            } else {
                item.content = null;
            }
        });
        this.setState({ panes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({
            activeKey,
        }, () => {
            this.updatePanes();
        });
    }

    render() {
        const { exportable } = this.props;
        const { panes, activeKey, areaOptions, searchParams } = this.state;
        return (
            <div>
                <div className="reportTitle">{this.props.title}</div>
                <Filter
                    search={this.search}
                    params={searchParams}
                    areaOptions={areaOptions}
                    onChange={this.handleFilterChange}
                    buttons={[
                        exportable ?
                            <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>
                        :
                            <Button key="export" disabled={true} style={{marginLeft: 8}}>导出</Button>
                    ]}
                />
                <Tabs type="card" activeKey={activeKey} onChange={this.handleTabsChange}>
                    {panes.map(pane => <TabPane tab={pane.title} key={pane.key} disabled={pane.disabled}>{pane.content}</TabPane>)}
                </Tabs>
            </div>
        );
    }
}

export default CrcDistributionJoinPro;


// WEBPACK FOOTER //
// ./src/components/homePage/statement/crcDistributionJoinPro.js